const parseFormData = (data) => {
  const { referenceId, durationInMinutes, employee, patient, treatmentReferenceId, title, comment } = data;
  return {
    duration: durationInMinutes,
    employeeReferenceId: employee == null ? void 0 : employee.referenceId,
    patient,
    openAppointmentReferenceId: referenceId,
    treatmentReferenceId,
    title,
    comment
  };
};
export {
  parseFormData
};
